import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { BusinessUnitService } from '../../business-unit/business-unit.service';

@Component({
  selector: 'crm-save-business-unit-shared-sales-bricks',
  templateUrl: './save-business-unit-shared-sales-bricks.component.html',
  styleUrls: ['./save-business-unit-shared-sales-bricks.component.css']
})
export class SaveBusinessUnitSharedSalesBricksComponent implements OnInit {
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() brickId: number;
  @Input() buLineId: number;
  @Input() brickName: string;
  @Input() buLineName: string;

  displayMode: DisplayModes = DisplayModes.Success;
  result;
  showError: boolean = false;
  showDateError: boolean = false;
  effectiveDate: string;

  constructor(private readonly alertService: AlertService,
    private readonly businessUnitService: BusinessUnitService,
    private readonly translateService: AppTranslationService) { }

  ngOnInit() {
    this.getSalesBrickBusinessUnits();
  }

  getSalesBrickBusinessUnits() {
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Searching"));
    this.displayMode = DisplayModes.Loading;

    this.businessUnitService.getSalesBrickBusinessUnits(this.brickId, this.buLineId)
      .subscribe(response => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.result = response as any[];
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
  }

  // same rule as the server: one unit 0 or 100; several units each above 0 and together 99.95-100
  // (equal shares that 100 can't be divided into exactly, e.g. 3 x 33.33 = 99.99, are accepted)
  private validShares(): boolean {
    const percents = this.result.map(x => Number(x.percent) || 0);
    if (percents.length === 1) return percents[0] === 0 || percents[0] === 100;
    const total = Math.round(percents.reduce((sum, p) => sum + p, 0) * 100) / 100;
    return percents.every(p => p > 0) && total >= 99.95 && total <= 100;
  }

  save(form) {
    this.showError = false;
    this.showDateError = false;

    if (!this.effectiveDate) {
      this.showDateError = true;
      return;
    }
    if (!this.validShares()) {
      this.showError = true;
      return;
    }

    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
    this.businessUnitService.saveSharedSalesBricksPercentage(this.brickId, this.result, new Date(this.effectiveDate))
      .subscribe(response => {
        this.alertService.stopLoadingMessage();
        this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
        this.displayMode = DisplayModes.Success;
        this.back();
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
  }

  back() {
    this.closeEvent.emit(false);
  }
}
